export type TEnumTranslation<TValue extends string> = {
  label: string;
  value: TValue;
};

type TCreateEnumTranslationsOptions<TValue extends string> = {
  values: readonly TValue[];
  translate: (value: TValue) => string;
  fallback: string;
};

export const createEnumTranslations = <TValue extends string>({
  values,
  translate,
  fallback,
}: TCreateEnumTranslationsOptions<TValue>) => {
  const all = (): TEnumTranslation<TValue>[] => values.map((value) => ({
    label: translate(value),
    value,
  }));

  const translateValue = (value: TValue | null): string => (
    value === null || !values.includes(value)
      ? fallback
      : translate(value)
  );

  const translateMany = (selectedValues: readonly TValue[] | null): string[] => (
    selectedValues === null
      ? [ fallback ]
      : selectedValues.map(translateValue)
  );

  return {
    all,
    translate: translateValue,
    translateMany,
  };
};
